"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import Image from "next/image";
import { useSanityConfig } from "@/contexts/SanityConfigContext";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { POST_BY_SLUG_QUERYResult } from "@/sanity/types";
type CaptionImage = NonNullable<
  Extract<
    NonNullable<NonNullable<POST_BY_SLUG_QUERYResult>["content"]>[number],
    { _type: "captionImageGroup" }
  >["images"]
>[number];

type ImageSlideProps = {
  value: NonNullable<
    NonNullable<NonNullable<POST_BY_SLUG_QUERYResult>["content"]>[number]
  > & {
    _type: "imageSlide";
  };
};

export function ImageSlide({ value }: ImageSlideProps) {
  const { urlFor } = useSanityConfig();

  return (
    <div className="flex flex-col pt-[24px] pb-[32px] md:pt-[28px] md:pb-[40px] md:px-[0px] border-t-2 border-[#31542B]">
      {(value.groupTitle || value.groupDescription) && (
        <div className="flex flex-col md:grid md:grid-cols-12 md:gap-[10px] gap-[20px] items-start">
          {value.groupTitle ? (
            <div className="md:col-span-2 flex flex-col items-start">
              <h2 className="text-[28px] leading-normal text-[#31542B] not-prose">
                {value.groupTitle}
              </h2>
            </div>
          ) : (
            <div className="md:col-span-3" />
          )}
          {value.groupDescription ? (
            <div className="md:col-span-3 flex flex-col gap-[24px] text-[#31542B] md:h-[100%] justify-between">
              <div className="text-medium md:text-medium font-lyon leading-normal not-prose">
                {value.groupDescription}
              </div>
              {value.groupTitleUrl ? (
                <a
                  href={value.groupTitleUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="md:text-small text-xsmall break-words text-[#92a190]"
                >
                  {value.groupTitleUrl}
                </a>
              ) : null}
            </div>
          ) : null}
          {Array.isArray(value.images) && value.images.length > 0 ? (
            <div className="w-full md:col-span-7 h-[300px]">
              <Swiper
                // modules={[]}
                spaceBetween={12}
                slidesPerView="auto"
                // scrollbar={{ draggable: true }}
                className="h-full"
              >
                {value.images.map((img: CaptionImage, idx: number) => (
                  <SwiperSlide
                    key={idx}
                    className="!w-auto h-full"
                    style={{ width: "auto" }}
                  >
                    <figure className="not-prose h-full">
                      {img.image?.asset && (
                        <div
                          className={`relative overflow-hidden rounded-[5px] ${
                            (img.metadata?.dimensions?.aspectRatio ?? 1.5) < 1
                              ? "h-full"
                              : "w-[300px] lg:w-[360px]"
                          }`}
                          style={{
                            aspectRatio:
                              img.metadata?.dimensions?.aspectRatio ?? 1.5,
                          }}
                        >
                          <Image
                            src={urlFor(img.image).url()}
                            alt={
                              img.title ||
                              img.description ||
                              img.location ||
                              value.groupTitle ||
                              ""
                            }
                            className="object-cover w-full h-full"
                            fill
                          />
                        </div>
                      )}
                    </figure>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
}
